import { render, staticRenderFns } from "./RefExtras.vue?vue&type=template&id=6479b9bb&scoped=true"
import script from "./RefExtras.vue?vue&type=script&lang=js"
export * from "./RefExtras.vue?vue&type=script&lang=js"
import style0 from "./RefExtras.vue?vue&type=style&index=0&id=6479b9bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6479b9bb",
  null
  
)

export default component.exports